import React, { useEffect, useState } from "react";

import ClaimStatusDetailsGrid_v2 from "./ClaimStatusDetailsGrid_v2";

import { IMemberDetails } from "../../../types/memberDetails.types";
import { IClaim_V2_Details } from "../../../types/claim_v2.types";
import { api } from "../../../utils/api";
import { Paper } from "@mui/material";

const ClaimStatus_v2 = () => {
	const [memberDetails, setMemberDetails] = useState<IMemberDetails | null>(null);
	const [claimStatusDetails, setClaimStatusDetails] = useState<IClaim_V2_Details[]>([]);
	const fetchClaimStatusDetails = async () => {
		const SSN = "462898389";
		const wltDob = "7-20-1987";
		const taxID = "382152450";
		const wltDateOfService = "8-13-2024";
		try {
			const response = await api.claim.getClaimStatusDetails(SSN, wltDob, taxID, wltDateOfService);
			// console.log("ClaimV2-->", response);
			setClaimStatusDetails(response?.claimResult);
			setMemberDetails(response?.memberResult);
			// handle the response
		} catch (error) {
			console.error("Error fetching claim status details:", error);
		}
	};
	useEffect(() => {
		fetchClaimStatusDetails();
	}, []);
	return (
		<>
			<div
				style={{
					height: "400px",
					width: "90%",
					margin: "auto",

					textAlign: "center",
					marginTop: "40px"
				}}
			>
				{/* <div className="pf-title" style={{ marginTop: "35px", marginBottom: "20px" }}>
					Claim Status
				</div> */}
				<Paper className="theme-border-radius paper-container">
					<ClaimStatusDetailsGrid_v2 memberDetails={memberDetails} claimStatusList={claimStatusDetails} />
				</Paper>
			</div>
		</>
	);
};

export default ClaimStatus_v2;
